module.exports = __webpack_public_path__ + "static/img/bot_01.21be47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot_01.png
// module id = KvIf
// module chunks = 14